<div class="apply-one-grid apply-one-style">
  <ng-container *ngIf="contractsByBrand; then contractSelector else loader"></ng-container>
</div>

<!-- usage selector -->
<ng-template #contractSelector>
  <div class="site-width">
    <div class="container-fluid pt-1 pt-md-3 pb-2 pb-md-3">
      <a [routerLink]="['/accueil']" class="o-link-arrow mb-2"
        >{{ 'ecm.selector.contract.homepageLinkLabel' | translate }}</a
      >
      <h1>{{ 'ecm.selector.contract.title' | translate }}</h1>

      <!-- contracts list -->
      <ng-container *ngIf="contractsByBrand.size > 0; else noContractAvailable">
        <div
          *ngFor="let brand of brandsAvailable; let isFirst = first; let isLast = last"
          [ngClass]="{'mb-2 mb-md-3': contractsByBrand.size > 1 && !isLast}"
        >
          <!-- other universe title, when multiple brand are available -->
          <h3 *ngIf="contractsByBrand.size > 1 && !isFirst">
            {{ 'ecm.selector.universe.' + brand + '.title' | translate }}
          </h3>

          <ul class="items-list row">
            <li *ngFor="let contract of contractsByBrand.get(brand)" class="col-12 col-md-6">
              <ecm-mat-item-list
                [e2e]="contract.cid"
                [itemIcon]="isFirst
                                        ? ('ecm.selector.contract.' + contract.universe + '.' + getContractActivity(contract) + '.icon' | translate)
                                        : reverseBrandLogoUrl"
                [itemLabel]="'ecm.selector.contract.'
                                        + contract.universe + '.' + getContractActivity(contract) + '.label' | translate: {
                                        offerName: contract.offerName
                                    }"
                [itemText]="contractDescriptions.get(contract.cid)"
                [itemPath]="getReturnUrl(contract.cid)"
                (materialItemListEvent)="redirectToReturnUrl(contract)"
              ></ecm-mat-item-list>
            </li>
          </ul>
        </div>
      </ng-container>

      <!-- no contract available -->
      <ng-template #noContractAvailable>
        <div class="text-mw">
          <ecm-mat-alert
            [style]="'warning'"
            [title]="'ecm.selector.error.unavailable.title' | translate"
          ></ecm-mat-alert>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- rebound links -->
  <ecm-selector-rebound-links *ngIf="!isWebviewContext" [universe]="universe"></ecm-selector-rebound-links>
</ng-template>

<!-- loader -->
<ng-template #loader>
  <div class="py-5">
    <ecm-mat-spinner></ecm-mat-spinner>
  </div>
</ng-template>
